/**
 * Natural/alphanumeric comparison function that correctly sorts strings with numbers.
 * Example: "Block 2" < "Block 10" (instead of alphabetic where "Block 10" < "Block 2")
 */
export function naturalCompare(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}
